/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* CreditApproval Page: https://www.creative-tim.com/creditApproval/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Alert,
  Card,
  CardHeader,
  Col,
  CardFooter,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
// core components
import UserCreditApprovals from "components/Tables/UserCreditApproval";
import Header from "components/Headers/CreditApprovalHeader";
import CreditApprovalDataService from "../../services/CreditApprovalDataService";

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultModal: false,
      creditApprovals: [],
      perPage: 10,
      currentPage: 1,
      currentCreditApproval: {},
    };
    this.CreditApprovalDataService = new CreditApprovalDataService();
  }

  toggleModal = (state, formType, creditApproval) => {
    this.setState({
      [state]: !this.state[state],
      formType: formType,
      currentCreditApproval: creditApproval,
    });
  };

  componentDidMount() {
    this.fetchData()
  }

  fetchData(keyword) {
    this.CreditApprovalDataService.getList(this.state.currentPage, this.state.perPage)
      .then(res => this.setState(res));
    setTimeout(() => {
      this.setState({ errorMessage: undefined })
    }, 5000);
  }

  handlePageClick = (e) => {
    const selectedPage = e;

    this.setState({
      currentPage: selectedPage,
    }, () => {
      this.fetchData(this.state.keyword)
    });
  }

  handleNextPageClick() {
    this.handlePageClick(this.state.currentPage + 1)
  }

  handlePreviousPageClick() {
    this.handlePageClick(this.state.currentPage - 1)
  }

  setSuccessMessage = (message) => {
    this.setState({ successMessage: message })
  }

  setErrorMessage = (message) => {
    this.setState({ errorMessage: message })
    setTimeout(() => {
      this.setState({ errorMessage: undefined })
    }, 5000);
  }

  render() {
    const pageNumbers = [];
    for (var index = 1; index <= this.state.totalPages; index++) {
      pageNumbers.push(index)
    }

    const renderPageNumbers = pageNumbers.map(number => {
      return (
        <PaginationItem className={this.state.currentPage === number ? "active" : ""}>
          <PaginationLink
            onClick={() => this.handlePageClick(number)}
          >
            {number}
          </PaginationLink>
        </PaginationItem>
      )
    })

    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Daftar approval kredit user</h3>
                    </Col>
                    {this.state.successMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="success">
                          {this.state.successMessage}
                        </Alert>
                      </Col>
                    )}
                    {this.state.errorMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="danger">
                          {this.state.errorMessage}
                        </Alert>
                      </Col>
                    )}
                  </Row>
                </CardHeader>
                <UserCreditApprovals
                  creditApprovals={this.state.creditApprovals}
                  toggleModal={this.toggleModal}
                  formModal={this.state.formModal}
                  formType={this.state.formType}
                  setSuccessMessage={this.setSuccessMessage}
                  setErrorMessage={this.setErrorMessage}
                  fetchData={this.fetchData.bind(this)}
                />
                <CardFooter className="py-4">
                  {this.state.totalPages > 1 && (
                    <nav aria-label="...">
                      <Pagination
                        className="pagination justify-content-end mb-0"
                        listClassName="justify-content-end mb-0"
                      >
                        <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                          <PaginationLink
                            onClick={() => this.handlePreviousPageClick()}
                            tabIndex="-1"
                          >
                            <i className="fas fa-angle-left" />
                            <span className="sr-only">Previous</span>
                          </PaginationLink>
                        </PaginationItem>
                        {renderPageNumbers}
                        <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                          <PaginationLink
                            onClick={() => this.handleNextPageClick()}
                          >
                            <i className="fas fa-angle-right" />
                            <span className="sr-only">Next</span>
                          </PaginationLink>
                        </PaginationItem>
                      </Pagination>
                    </nav>
                  )}
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default List;
